import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from '../../node_modules/classnames/index.js';
import 'react';
import '@cheetahdigital/console-kit-cx';
import 'semantic-ui-react';
import 'react-dom';
import Icon from '../../shared/elements/Icon/index.js';
import styles from './index.module.scss.js';

var NavbarLink = function (_a) {
    var _b = _a.isDisableUnderline, isDisableUnderline = _b === void 0 ? false : _b, _c = _a.isActive, isActive = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, className = _a.className, style = _a.style, icon = _a.icon, children = _a.children;
    return (jsxs("div", __assign({ className: classNames(styles.navbarLink, isDisableUnderline && styles.isDisableUnderline, isActive && styles.isActive, isDisabled && styles.isDisabled, !!icon && styles.hasIcon, "navbarLink", isDisabled && "isDisabled", !!icon && "hasIcon", className), style: style }, { children: [children, !!icon && jsx(Icon, { name: icon }, void 0)] }), void 0));
};

export { NavbarLink as default };
